module.exports = __webpack_public_path__ + "static/media/car1.498d6d7e.svg";